import { ReceptionSaveResultBase } from "./base";

// 依頼受付・詳細登録結果model
export class ReceptionSaveResult extends ReceptionSaveResultBase {
}
